import Image from 'next/image';
import React, { useState } from 'react';

import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';

import { getCinemaLogo } from '@/helpers/cinema-helper';
import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';
import { cn } from '@cineamo/ui/src/helpers/cn';

import { IconLocation24 } from '@cineamo/ui/src/icons/ic-location';

const defaultCinemaImage = loadAsset('/images/placeholders/im-cinemaDummy.png');

export type CinemaPickerListItemProps = {
    className?: string;
    cinema: CinemaDto;
    onClick?: (cinema: CinemaDto) => void;
};

function CinemaPickerListItem(props: CinemaPickerListItemProps) {
    const { className, cinema } = props;

    // const router = useRouter();

    const [error, setError] = useState(false);

    // Render-time state sync: reset error when cinema changes
    const [prevCinema, setPrevCinema] = useState(cinema);
    if (prevCinema !== cinema) {
        setPrevCinema(cinema);
        setError(false);
    }

    // const { showLoadingAnimation, hideLoadingAnimation } = useLoadingAnimation();

    function changeSelectedCinema(newCinema: CinemaDto) {
        if (props.onClick) {
            props.onClick(newCinema);
        }

        // changeCinemaRedirect(router, newCinema, showLoadingAnimation, hideLoadingAnimation);
    }

    const imageUrl = getCinemaLogo(cinema, true);

    return (
        <div
            className={cn(
                className,
                'w-full px-16 py-8 flex flex-row cursor-pointer items-center transition-all duration-200',
                'hover:bg-purple/20 active:opacity-80',
                'select-none group'
            )}
            onClick={() => changeSelectedCinema(cinema)}
            title={cinema.name}>
            <div className="flex flex-row items-center space-x-8 mr-8">
                <div className={cn('rounded-full relative flex-none overflow-hidden w-24 h-24')}>
                    <Image
                        className="w-full h-full object-cover"
                        src={!error && imageUrl ? imageUrl : defaultCinemaImage}
                        width={100}
                        height={100}
                        onError={() => setError(true)}
                        onErrorCapture={() => setError(true)}
                        alt={`${cinema.name} cinema image`}
                    />
                </div>
                <span className="whitespace-nowrap text-ellipsis overflow-hidden">{cinema.name}</span>
            </div>
            <IconLocation24 className="flex-none ml-auto opacity-0 group-hover:opacity-100 transition-all duration-200" />
        </div>
    );
}

export default CinemaPickerListItem;
